import { SizesProp } from '@lib/types';

type Reference = { width: number; gap: number; max: number };

const REM = 16; // converts rem to px
const REFERENCE: Record<keyof SizesProp, Reference> = {
  // base: { width: 6 * REM, gap: 1 * REM, max: 4 },
  sm: { width: 5.5 * REM, gap: 2 * REM, max: 6 },
  md: { width: 5.5 * REM, gap: 2 * REM, max: 8 },
  lg: { width: 3 * REM, gap: 2 * REM, max: 12 },
  xl: { width: 4.5 * REM, gap: 2 * REM, max: 12 },
  full: { width: 5 * REM, gap: 2 * REM, max: 12 },
};

// HELPER METHOD
// Calculate the pixel width of given column counts
// Intended to be used to generate responsive image sizes
// Define key breakpoints
// Fewer the better, but you can define as many as you want

// Example: columnsToSizes({ sm: 6, lg: 6, full: 4 })
// Would render:
// Full width on sm (of 6 columns)
// 1/2 width on lg (of 12 columns)
// 1/3 width on full (of 12 columns)

// Accepts optional multiplier to scale the final result

export function columnsToSizes(
  cols: {
    // base?: number | string;
    sm?: number | string;
    md?: number | string;
    lg?: number | string;
    xl?: number | string;
    full?: number | string;
  },
  multiplier?: number,
) {
  const sizes: SizesProp = {};

  // if (cols.base) sizes.base = toPx(REFERENCE.base, cols.base, multiplier);
  if (cols.sm) {
    sizes.sm = toPx(REFERENCE.sm, cols.sm, multiplier);
  }
  if (cols.md) {
    sizes.md = toPx(REFERENCE.md, cols.md, multiplier);
  }
  if (cols.lg) {
    sizes.lg = toPx(REFERENCE.lg, cols.lg, multiplier);
  }
  if (cols.xl) {
    sizes.xl = toPx(REFERENCE.xl, cols.xl, multiplier);
  }
  if (cols.full) {
    sizes.full = toPx(REFERENCE.full, cols.full, multiplier);
  }

  return sizes;
}

// returns a pixel value
function toPx({ width, gap, max }: Reference, cols: number | string, multiplier = 1): string {
  if (typeof cols === 'string') {
    return cols;
  }

  const count = Math.min(cols, max);
  const colSize = width * count;
  const gapSize = gap * (count - 1);
  const total = Math.ceil((colSize + gapSize) * multiplier);

  return `${total}px`;
}
